import { Controller } from "@hotwired/stimulus"
import SlimSelect from "slim-select"

export default class extends Controller {
  static values = { 
    placeholder: String,
    searchable: Boolean,
    closeOnSelect: Boolean,
    allowDeselect: Boolean
  }

  connect() {
    this.slimSelect = new SlimSelect({
      select: this.element,
      settings: {
        // Always show search regardless of option count
        showSearch: true,
        searchFilter: true,
        placeholderText: this.placeholderValue || 'Select...',
        searchPlaceholder: 'Search...',
        searchText: 'No results',
        searchingText: 'Searching...',
        allowDeselect: this.allowDeselectValue !== false,
        closeOnSelect: this.element.multiple ? false : true
      },
      events: {
        afterChange: (newVal) => {
          // Dispatch a change event for other listeners
          const event = new Event('change', { bubbles: true })
          this.element.dispatchEvent(event)
        }
      }
    })
  }

  disconnect() {
    if (this.slimSelect) {
      this.slimSelect.destroy()
    }
  }
}